import React, { FC } from "react";
import { Dropdown } from "react-bootstrap";
import { useLogout } from "../../../hooks/useLogout";
import { ChildrenProps } from "../../../types";
import styles from "./NavigationDropdown.module.scss";

export interface NavigationDropdownProps extends ChildrenProps {
    toggle: React.ElementType;
    header?: React.ReactNode;
}

export const NavigationDropdown: FC<NavigationDropdownProps> = ({
    toggle,
    header,
    children,
}) => {
    const logout = useLogout();

    return (
        <Dropdown className={styles.dropdown}>
            <Dropdown.Toggle as={toggle}></Dropdown.Toggle>
            <Dropdown.Menu className={styles.dropdownMenu} align="left">
                {header ? (
                    <>
                        {header}
                        <Dropdown.Divider />
                    </>
                ) : null}

                {children}

                <Dropdown.Item onClick={logout} data-testid="logout-button">
                    Log out
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};
